/**
 * Connectivity Monitor
 *
 * Avisa al usuario cuando pierde o recupera la conexión a Internet.
 * Las escrituras a Firestore quedan en cola offline mientras tanto
 * (Firebase SDK lo maneja automáticamente con persistencia local).
 */

import toast from "react-hot-toast";

let offlineToastId: string | undefined;

export function setupConnectivityMonitor(): void {
  if (typeof window === "undefined") return;

  window.addEventListener("offline", () => {
    if (offlineToastId) toast.dismiss(offlineToastId);
    offlineToastId = toast.error(
      "Sin conexión a Internet. Tus cambios se guardarán cuando vuelvas a estar en línea.",
      {
        id: "connectivity-offline",
        duration: Infinity,
        icon: "📡",
      },
    );
  });

  window.addEventListener("online", () => {
    if (offlineToastId) {
      toast.dismiss(offlineToastId);
      offlineToastId = undefined;
    }
    toast.success("Conexión restablecida.", {
      id: "connectivity-online",
      duration: 3000,
      icon: "✅",
    });
  });

  // Estado inicial: si arranca offline, avisar
  if (!navigator.onLine) {
    offlineToastId = toast.error(
      "Sin conexión a Internet. Algunas funciones no estarán disponibles.",
      { id: "connectivity-offline", duration: Infinity, icon: "📡" },
    );
  }
}
